<template>

    <div class="animated fadeIn">

        <b-row class="mt-2">
            <b-col>
                <h5>¿Tiene algún comentario, sugerencia u observación?</h5>
            </b-col>
        </b-row>

        <b-row class="mt-2">
            <b-col>
                <b-form-textarea
                    v-model="comments"
                    :rows="3"
                    :max-rows="6">
                </b-form-textarea>
            </b-col>
        </b-row>

    </div>

</template>

<script>

    export default {
        name: "CommentsQuestion",
        props: {
            value: String
        },
        data: function () {
            return {
                comments: null
            }
        },
        watch: {
            'comments': function(){
                this.$emit('input', this.comments);
            },
        }
    }
</script>